import { render, staticRenderFns } from "./Componente.vue?vue&type=template&id=12668058&scoped=true&"
import script from "./Componente.vue?vue&type=script&lang=js&"
export * from "./Componente.vue?vue&type=script&lang=js&"
import style0 from "./Componente.vue?vue&type=style&index=0&id=12668058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12668058",
  null
  
)

export default component.exports